import { FC } from 'react';
import { getCategoryIcon } from '../../../../lib/helpers';

type CategoryIconProps = {
  categoryCode?: string | null;
  custom: boolean;
  className?: string;
  style?: React.CSSProperties;
};

export const CategoryIcon: FC<CategoryIconProps> = ({ categoryCode, custom, className, style }) => {
  const Icon = getCategoryIcon(custom, categoryCode);
  return <Icon role="img" aria-label={categoryCode + ' category icon'} className={className} style={style} />;
};
